import './i18n'; // This ensures your i18n config is loaded
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { DrinkCustomizationProvider } from './contexts/DrinkCustomizationContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { AppSettingsProvider } from './contexts/AppSettingsContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// console.log('index.tsx');

root.render(
  <React.StrictMode>
    <AppSettingsProvider>
      <LanguageProvider>
        <WebSocketProvider>
          <DrinkCustomizationProvider>
            <App />
          </DrinkCustomizationProvider>
        </WebSocketProvider>
      </LanguageProvider>
    </AppSettingsProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
